import { useQuery } from '@tanstack/react-query';
import { fetchTimezones } from '@/api';
import timezoneKeys from '@/queries/timezone/timezoneKeys';

const queryFn = async () => {
    const { axios, ...data } = await fetchTimezones();

    return data;
};

const useTimezonesQuery = () => {
    return useQuery({
        queryKey: timezoneKeys.list(),
        queryFn,
        staleTime: Infinity,
    });
};

export default useTimezonesQuery;
